var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternational(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_65_142)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 13.2215,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_142",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H43V43H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9062 25.5011C41.9062 34.5617 34.5606 41.9073 25.5 41.9073C16.4394 41.9073 9.09375 34.5617 9.09375 25.5011M41.9062 25.5011C41.9062 16.4405 34.5606 9.09484 25.5 9.09484C16.4394 9.09484 9.09375 16.4405 9.09375 25.5011M41.9062 25.5011H9.09375M20.9434 9.73677C18.278 14.3797 16.7544 19.7632 16.7544 25.501C16.7544 31.2388 18.2769 36.6222 20.9434 41.2652M30.0608 41.2632C32.7274 36.6214 34.2499 31.239 34.2499 25.5012C34.2499 19.7656 32.7263 14.3854 30.063 9.73917M38.2469 35.8245C34.3466 34.1127 30.0361 33.1612 25.5047 33.1612C20.9689 33.1612 16.6563 34.1149 12.7527 35.8288M12.7563 15.1788C16.6566 16.8938 20.9692 17.8454 25.5039 17.8454C30.0375 17.8454 34.348 16.8927 38.2516 15.1788M25.4989 9.09375V41.9062",
    stroke: "#2A4887",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_65_142",
    x: -16.7473,
    y: -16.7473,
    width: 84.4945,
    height: 84.4945,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.37364
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_65_142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_65_142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternational);
export default __webpack_public_path__ + "static/media/international.883c85385d1d91d5e88dfe1fb3e91bae.svg";
export { ForwardRef as ReactComponent };